export default "__VITE_ASSET__64be3d32__"